export default __webpack_public_path__ + "static/media/facebookIcon.63bda79c.svg";